import { listEmployee } from "@/api/system/employee";
import { listAllStation } from "@/api/system/station";
import { listAllEntity } from "@/api/kl/entity";
import { listAllCompany } from "@/api/system/company";
import { listChannel } from "@/api/pay/channel";
/**
 * presetFunction_
 */
export default {
    /** 公司 presetFunction_systemCompany */
    systemCompany: {
        queryFunction: listAllCompany,
        fieldNames: { value: 'cpid', label: 'companyName' }
    },
    /** 组织信息 presetFunction_systemStation */
    systemStation: {
        queryFunction: listAllStation,
        fieldNames: { value: 'id', label: 'stationName' }
    },
    /** 支付渠道 presetFunction_payChannel */
    payChannel: {
        queryFunction: listChannel,
        fieldNames: { value: 'id', label: 'channelName' }
    },
    systemEmployee: {
        queryFunction: listEmployee,
        fieldNames: { value: 'employeeId', label: 'employeeName' }
    },
    /** 实体信息 presetFunction_klEntity */
    klEntity: {
        queryFunction: listAllEntity,
        fieldNames: { value: 'id', label: 'entityName' }
    },
}